import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import Caution from "../../components/caution";
import MyLink from "../../components/myLink";
import Note from "../../components/note";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
      1.0 Routine Patient Care
      </MyLink>
      , followed by:
    </li>
  </ul>
  <ol style={{
        padding: '0 1rem'
      }}>
    <li>
      One EMT should manage the patient while the other handles scene control, but no
      EMT or First Responder should be left alone with the patient.
    </li>
    <li>
      Avoid areas/patients with potential weapons (e.g., kitchen, workshop), and avoid
      areas with only a single exit; do not allow patient to block exit.
    </li>
    <li>
      Keep environment calm by reducing stimuli (may need to ask family/friends to
       leave room, ask patient to turn off music/TV). Transport in a non-emergent mode
       unless the patient’s condition requires lights and sirens.
    </li>
    <li>
      Respect the dignity and privacy of the patient.
    </li>
    <li>
      Make eye contact when speaking to the patient.
    </li>
    <li>
      Speak calmly and in a non-judgmental manner; do not make sudden movements.
    </li>
    <li>
      Maintain non-threatening body language (hands in front of your body, below your
      chest, palms out and slightly to the sides).
    </li>
    <li>
      Establish expectations for acceptable behavior, if necessary.
    </li>
    <li>
      Ask permission to touch the patient before taking vital signs, and explain what
       you are doing.
    </li>
    <li>
      Assess the patient to the extent that they allow without increasing agitation,
       maintain a safe distance from a violent patient.
    </li>
    <li>
      Stop talking with patient if they demonstrate increased agitation; allow time for
       them to calm down before attempting to discuss options again.
    </li>
    <li>
      Provide reassurance by acknowledging the crisis and validating the patient’s
       feelings and concerns; use positive feedback, not minimization.
    </li>
    <li>
      Determine risk to self and others (“Are you thinking about hurting/killing yourself
       or others?”).
    </li>
    <li>
      Encourage patient to cooperatively accept transport to the hospital for a
       psychiatric evaluation and treatment.
    </li>
    <li>
      Consider asking friends/relatives on scene to encourage patient to accept
       transport, if needed; but only if they are not a source of agitation.
    </li>
    <li>
      Ask law enforcement or Online Medical Control to complete a MDMH Section 12
      application for uncooperative patients who acknowledge intent to self-harm or
      harm others, but do not delay transport in the absence of this document.
    </li>
    <li>
      Use restraints in accordance with 2.5 Behavioral Emergencies: Restraint if
       de-escalation strategy fails and the patient is a danger to him/herself or others.
    </li>
  </ol>
  <strong>Acute risk factors for violence include:</strong>
  <ul style={{
        padding: "0.5rem 1rem"
      }}>
    <li>
      Male gender
    </li>
    <li>
      Homicidal or violent intent or plans
    </li>
    <li>
      Intoxication or recent substance use
    </li>
    <li>
      Actions taken on plans/threats
    </li>
    <li>
      Unconcerned with consequences
    </li>
    <li>
      No alternatives to violence seen
    </li>
    <li>
      Intense fear, anger, or aggressive speech/behavior
    </li>
    <li>
      Specified victim (consider proximity, likelihood of provocation)
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  Follow above protocols
    </EMTLevel>
    <Caution id="caution-1" style={{
      marginBottom: '2rem'
    }} mdxType="Caution">
  Haloperidol should be administered by INTRAMUSCULAR injection ONLY.
    </Caution>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  <ul>
    <li>
      Initiate an IV of Normal Saline at a KVO rate.
    </li>
    <li>
      Apply cardiac monitor if clinically feasible, obtain 12 lead ECG-manage
      dysrhythmias per protocol.
    </li>
    <li>
      Position patient to ensure breathing is not impaired.
    </li>
    <li>
      If providing medication to patients &gt; 70 years of age, limit dose.
    </li>
  </ul>
  <strong>
    ADULT STANDING ORDERS:
  </strong>
  <ul>
    <li>
      Haloperidol 5 mg IM; and/or
    </li>
    <li>
      Midazolam 2-6 mg IV/IO/IM/IN
    </li>
    <li>
      Ketamine 4mg/kg IM only, to a maximum dose of 400mg IM only, as a
      single dose.
    </li>
    <li>
      <strong>NOTE:</strong> In patients >70 years of age, limit medication to half these
      doses.
    </li>
  </ul>
  <strong>
    PEDIATRIC STANDING ORDERS:
  </strong>
  <ul>
    <li>
      Midazolam 0.1mg/kg IV/IO/IM/IN, to maximum dose of 6 mg.
    </li>
  </ul>
    </EMTLevel>
    <Note id="note-1" mdxType="Note">
  Medical Control may order additional doses of above medication
    </Note>
    <Caution id="caution-2" mdxType="Caution">
  Haloperidol is preferable for psychotic patients; but do not administer to patients with a
  history of seizures or prolonged QT intervals.
    </Caution>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      